module.exports = "\n<div class=\"pop-400\">\n    <header class=\"dialog-header flex-item\">\n      <h2></h2>\n        <button md-dialog-close class=\"close-btn\">\n            <i class=\"material-icons\">clear</i>\n        </button>\n    </header>\n    <dir>{{ message }}</dir>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modalbox/modal-box.component.html
// module id = 2342
// module chunks = 0